import * as dashboardTypes from './dashboardTypes';
//import { MESSAGING_URL, MESSAGING_COMPOSE_URL, TIMER_START, TIMER_TYPES, MSG_MONITOR_INTERVAL, TIMER_STOP } from 'src/constants/constants';
import { TIMER_START, TIMER_TYPES, MSG_MONITOR_INTERVAL, TIMER_STOP } from 'src/constants/constants';
import { fetchDashboardHeaderCount } from 'src/services/dashboard.service';

import { fetchEngagements, fetchCasePhasesService, fetchFavoriteCasesService } from 'src/services/dashboard.service';
import { setFavoriteMarkService } from 'src/services/cases.service';
//import { push } from 'react-router-redux';

export const fetchDashboardHeaderCountsPending = () => ({
  type: dashboardTypes.FETCH_DASHBOARD_HEADER_COUNTS_PENDING,
});

export const fetchDashboardHeaderCountsSuccess = data => {
  return {
    type: dashboardTypes.FETCH_DASHBOARD_HEADER_COUNTS_SUCCESS,
    data,
  };
};

export const fetchDashboardHeaderCountsFailure = err => ({
  type: dashboardTypes.FETCH_DASHBOARD_HEADER_COUNTS_FAILURE,
  err,
});

export const getDashboardCounts = opts => {
  return (dispatch, getState, setLock, onStart, onComplete) => {
    onStart();

    let arr = [{ action: fetchDashboardHeaderCount() }];

    Promise.all(arr.map(each => each.action)).then(result => {
      try {
        if (result[0].error) {
          const { error } = result[0];
          if (error.code && error.code === '403') {
            dispatch(fetchDashboardHeaderCountsFailure(error));
          }
          throw Error(error.message);
        }
        dispatch(fetchDashboardHeaderCountsSuccess(result[0]));
        setLock(false);
        onComplete();
      } catch (error) {
        dispatch(fetchDashboardHeaderCountsFailure(error));
        setLock(false);
      }
    });
    setLock(true);
  };
};

export const runCountsMonitor = opts => {
  return {
    type: TIMER_START,
    payload: {
      name: TIMER_TYPES.DASHBOARD_COUNTS_MONITOR,
      timeout: MSG_MONITOR_INTERVAL,
      action: getDashboardCounts(opts),
      ...opts,
    },
  };
};

export const viewAllMessages = () => {
  // return push(MESSAGING_URL);
};

export const composeNewMessage = () => {
  // return push(MESSAGING_COMPOSE_URL);
};

export const getEngagementsPending = () => {
  return async dispatch => {
    await fetchEngagements()
      .then(res => {
        if (res.success) dispatch(getEngagementsSuccess(res.messages));
        else throw new Error(res.error.message);
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getEngagementsSuccess = res => ({
  type: dashboardTypes.GET_ENGAGEMENTS_SUCCESS,
  res,
});

export const getCasePhasesSuccess = data => ({
  type: dashboardTypes.GET_CASE_PHASES_SUCCESS,
  data,
});

export const getCasePhases = () => {
  return async dispatch => {
    const { success, ...response } = await fetchCasePhasesService();

    if (success) {
      dispatch(getCasePhasesSuccess(response));
    }
  };
};

export const fetchFavoriteCases = data => {
  return async dispatch => {
    await fetchFavoriteCasesService(data)
      .then(res => {
        if (res.success) {
          dispatch(getFavoriteCasesSuccess(res));
        } else throw new Error(res.error.message);
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const setFavoriteCase = (caseManagerId, isChecked, rowIndex) => {
  return async dispatch => {
    try {
      let { response } = await setFavoriteMarkService({
        caseManagerId: caseManagerId,
        IsFavorite: isChecked,
      });
      dispatch(setFavoriteCaseSuccess(rowIndex, isChecked));
      if (response && !response.success) dispatch(setFavoriteCaseSuccess(rowIndex, !isChecked));
    } catch (error) {
      dispatch(setFavoriteCaseSuccess(rowIndex, !isChecked));
    }
  };
};

export const getFavoriteCasesSuccess = payload => ({
  type: dashboardTypes.GET_FAVORITE_CASE,
  payload,
});

export const setFavoriteCaseSuccess = (payload, isChecked) => ({
  type: dashboardTypes.SET_DASHBORD_CASE_UPDATE,
  payload,
  isChecked,
});

export const dashboardSelectMessage = () => {
  // return push(MESSAGING_URL);
};

export const dashboardStoreSelectedMessageId = id => ({
  type: dashboardTypes.STORE_SELECTED_MESSAGE_ID,
  id,
});

export const stopCountsMonitor = () => {
  return {
    type: TIMER_STOP,
    payload: {
      name: TIMER_TYPES.DASHBOARD_COUNTS_MONITOR,
    },
  };
};

export const storeSelectedEngagement = engagement => {
  return {
    type: dashboardTypes.STORE_SELECTED_ENGAGEMENT,
    payload: {
      engagement: engagement,
    },
  };
};

export const resetSelectedMessageId = () => {
  return {
    type: dashboardTypes.RESET_SELECTED_MESSAGE_ID,
  };
};

export default {
  composeNewMessage,
  fetchDashboardHeaderCountsPending,
  fetchDashboardHeaderCountsSuccess,
  fetchDashboardHeaderCountsFailure,
  getEngagementsPending,
  viewAllMessages,
  dashboardSelectMessage,
  storeSelectedEngagement,
  fetchFavoriteCases,
  setFavoriteCase,
};



// WEBPACK FOOTER //
// ./src/ui/features/Dashboard/state/dashboardActions.js